<div class="issues">
  @if (isBannerVisible()) {
    <div class="preview-banner-container">
      <app-issues-preview-banner [isVisible]="isBannerVisible()" (closed)="closeBanner()" />
    </div>
  }

  <div class="table-actions">
    @if (pageFilters) {
      <app-issues-filters class="filters-flex" [pageFilters]="pageFilters"></app-issues-filters>
    }
    @if (!hideBannerFlag()) {
      <button
        type="button"
        class="banner-toggle-btn"
        [class.banner-toggle-btn--active]="isBannerVisible()"
        (click)="toggleBanner()"
        matTooltip="Show info about Issues"
        matTooltipPosition="left"
        matTooltipClass="issues-info-tooltip"
        aria-label="Toggle info banner"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
          <line x1="12" y1="16" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <circle cx="12" cy="8" r="1" fill="currentColor" />
        </svg>
      </button>
    }
  </div>

  <div class="table-header">
    @if (totalItems() > -1) {
      <div class="resources-amount">
        {{ 'common.found' | labelsProvider }} {{ totalItems() | number }}
        {{ 'issues' }}
      </div>
    }
    <app-option-toggle
      [options]="classificationOptions()"
      [selectedValue]="selectedTab()"
      (valueChange)="onTabChangeByValue($event)"
    />
  </div>

  <div class="table">
    @if (pageFilters) {
      <app-issues-vertical-filters
        [ngClass]="{ 'filters-all': isFiltersMenuOpen() }"
        (optionOnSelection)="tablesFiltersChange($event)"
        [pageFilters]="pageFilters"
        [isFiltersMenuOpen]="isFiltersMenuOpen()"
        (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
      />
    }

    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen() ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="issues"
      [data$]="issuesCurrentPage$"
      [rowsPerPage]="50"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      (rowSelected)="rowSelected($event)"
      (rowUnselected)="rowUnselected()"
      (pageOnChange)="onPagination($event)"
      [withCheckboxSelection]="false"
      [withActions]="false"
      [sortedColumn$]="pageFilters.sortedColumn$"
      [pageInfo]="pageInfo$.value"
      [tabelWithIcon]="false"
      [withSpacerColumn]="true"
      tableNotFoundText="No issues found"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
    />
  </div>
</div>
